import Vue from "vue"

const url = "/api"
const ubigeoUrl = "/api/commons/ubigeo"
class CommonsService {
	async getCargos() {
		try {
			return await Vue.axios.get(`${url}/get-privileges`)
		} catch (err) {
			console.error(err)
		}
	}
	async getGeneralSettings() {
		try {
			const data = await axios.get(`${url}/brain/others/settings-generals/`)
			return data
		} catch (error) {
			throw error
		}
	}
	async editSettings({ name, value_text, value_number }) {
		try {
			const data = await axios.put(`${url}/brain/others/settings-generals/${name}`, { value_text, value_number })
			return data
		} catch (error) {
			throw error
		}
	}
	async viewedAdmin() {
		try {
			const data = await axios.post(`${url}/users/check-notification-alert`)
			return data
		} catch (error) {
			throw error
		}
	}

	async viewedBirthday() {
		try {
			const data = await axios.post(`${url}/users/check-notification`)
			return data
		} catch (error) {
			throw error
		}
	}
	async getFemaleChicks() {
		try {
			return await Vue.axios.get(`${url}/get-female-chicks-for-depuration`)
		} catch (err) {
			console.error(err)
		}
	}
	async getFemaleChicksDetail(corral_id) {
		try {
			return await Vue.axios.get(`${url}/get-female-chicks-depuration-detail`, { params: { corral_id } })
		} catch (err) {
			console.error(err)
		}
	}
	async getDepurationCounter(corral_id) {
		try {
			return await Vue.axios.get(`${url}/get-counter-chicks-depuration`)
		} catch (err) {
			console.error(err)
		}
	}
	async getCountries() {
		try {
			const { data } = await axios.get(`${ubigeoUrl}/countries`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async getDepartments() {
		try {
			const { data } = await axios.get(`${ubigeoUrl}/departments`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async getProvinces(department_id) {
		try {
			const { data } = await axios.get(`${ubigeoUrl}/provinces/${department_id}`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async getDistricts(province_id) {
		try {
			const { data } = await axios.get(`${ubigeoUrl}/districts/${province_id}`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
}
export default new CommonsService()
